import './App.css';
import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import store from './store';
import { contentActions } from './store/content';
import { isSiteInDarkMod } from '../../components/modules/Graph/GraphUtility';
import FilterPanelExample from '../../components/modules/FilterPanel/FilterPanelExample';
import { dataActions } from './store/data';
import { filtersActions } from './store/filters';
import { pathMapping } from './vars/pageMapping';

const themeSwitchHandler = () => {
  contentActions.setDarkMode(isSiteInDarkMod());
};

const getThemeSwitcher = () => {
  const items = document.querySelectorAll('.theme-switcher');

  return {
    addEventListener: () => {
      items.forEach((item) => {
        item.addEventListener('click', themeSwitchHandler);
      });
    },
    removeEventListener: () => {
      items.forEach((item) => {
        item.removeEventListener('click', this.themeSwitchHandler);
      });
    },
  };
};

function RegionalAnalysis(props) {
  const { apiurl } = props;

  const changeURL = window.location.pathname;
  const separate = changeURL.toString().split('/');
  const result = separate[separate.length - 1]; // Or parts.pop();

  store.dispatch(filtersActions.changeMapSelection(pathMapping[result]));

  store.dispatch(dataActions.setApiUrl(apiurl));

  useEffect(() => {
    getThemeSwitcher;
  }, []);

  return (
    <Provider store={store}>
      <FilterPanelExample />
    </Provider>
  );
}

export default RegionalAnalysis;
